module.exports = __webpack_public_path__ + "img/thumb-katya.a9d1ea80.jpg";